import React, { useState } from "react";
import imgAnchoLuz from "../../assets/images/icons/SVG/calculadora-bovedilla-hormigon.svg";
import t180 from "../../assets/json/t180.json";
import ResultCalculatorNot from "./ResultCalculatorNot";
import ResultsCalculator from "./ResultsCalculatorT180";
import { useLocation, useNavigate } from "react-router-dom";

const T180 = () => {
  const location = useLocation();
  const queryParams = new URLSearchParams(location.search);
  const [luzOriginal, setLuzOriginal] = useState(queryParams.toString().length > 0 && queryParams.get('luzOriginal'));
  const [anchoOriginal, setAnchoOriginal] = useState(queryParams.toString().length > 0 && queryParams.get('anchoOriginal'));
  const [sobreCarga1, setSobreCarga1] = useState(queryParams.toString().length > 0 ? queryParams.get('sobreCarga1') : 0);
  const [sobreCarga2, setSobreCarga2] = useState(queryParams.toString().length > 0 ? queryParams.get('sobreCarga2') : 0);
  const [carga1, setCarga1] = useState(queryParams.toString().length > 0 ? queryParams.get('carga1') : 0);
  const [carga2, setCarga2] = useState(queryParams.toString().length > 0 ? queryParams.get('carga2') : 0);
  const [res, setRes] = useState("");
  const [mensaje, setMensaje] = useState(
    "No es posible el cálculo con estos valores de carga ingresados. Revisa los valores y calcula nuevamente"
  );
  const [mensajeUser, setMensajeUser] = useState("");
  const [mostrarResultCalculatorNot, setMostrarResultCalculatorNot] =
    useState(false);
  const [mostrarMensajeUserNot, setMostrarMensajeUserNot] =
    useState(false);

  const navigate = useNavigate();
  const userLog = JSON.parse(localStorage.getItem("Usuario"));

  const luzOptions = [
    { value: null, label: "Luz (en metros)" },
    { value: 3.0, label: "3.00" },
    { value: 3.2, label: "3.20" },
    { value: 3.4, label: "3.40" },
    { value: 3.6, label: "3.60" },
    { value: 3.8, label: "3.80" },
    { value: 4.0, label: "4.00" },
    { value: 4.2, label: "4.20" },
    { value: 4.4, label: "4.40" },
    { value: 4.6, label: "4.60" },
    { value: 4.8, label: "4.80" },
    { value: 5.0, label: "5.00" },
    { value: 5.2, label: "5.20" },
    { value: 5.4, label: "5.40" },
    { value: 5.6, label: "5.60" },
    { value: 5.8, label: "5.80" },
    { value: 6.0, label: "6.00" },
    { value: 6.2, label: "6.20" },
    { value: 6.4, label: "6.40" },
    { value: 6.6, label: "6.60" },
    { value: 6.8, label: "6.80" },
    { value: 7.0, label: "7.00" },
    { value: 7.2, label: "7.20" },
    { value: 7.4, label: "7.40" },
    { value: 7.6, label: "7.60" },
    { value: 7.8, label: "7.80" },
    { value: 8.0, label: "8.00" },
    { value: 8.2, label: "8.20" },
    { value: 8.4, label: "8.40" },
    { value: 8.6, label: "8.60" },
    { value: 8.8, label: "8.80" },
    { value: 9.0, label: "9.00" },
    { value: 9.2, label: "9.20" },
    { value: 9.4, label: "9.40" },
    { value: 9.6, label: "9.60" },
    { value: 9.8, label: "9.80" },
    { value: 10.0, label: "10.00" },
    { value: 10.2, label: "10.20" },
    { value: 10.4, label: "10.40" },
    { value: 10.6, label: "10.60" },
    { value: 10.8, label: "10.80" },
  ];

  const buildingOptions = [
    { value: null, label: "Edificios de viviendas:" },
    { value: 500, label: "Azoteas y/o terrazas uso intensivo" },
    { value: 300, label: "Azoteas accesibles" },
    { value: 100, label: "Azoteas inaccesibles" },
    { value: 200, label: "Baños" },
    { value: 200, label: "Cocinas" },
    { value: 500, label: "Comedores y lugares de estar" },
    { value: 200, label: "Dormitorios" },
  ];

  const otherBuildingOptions = [
    { value: null, label: "Otros edificios:" },
    { value: 700, label: "Archivos" },
    { value: 300, label: "Aulas" },
    { value: 300, label: "Baños" },
    { value: 700, label: "Bibliotecas" },
    { value: 400, label: "Cocinas" },
    { value: 500, label: "Comedores" },
    { value: 750, label: "Cuarto de máquinas y calderas" },
    { value: 200, label: "Dormitorios" },
    { value: 500, label: "Gimnasios" },
    { value: 300, label: "Lavaderos" },
    { value: 300, label: "Locales para reunión con asiento fijo" },
    { value: 500, label: "Locales para reunión sin asiento fijo" },
    { value: 250, label: "Oficinas" },
    { value: 500, label: "Salones de Baile" },
    { value: 300, label: "Tribunas con asientos fijos" },
    { value: 500, label: "Tribunas sin asientos fijos" },
    { value: 250, label: "Vestuarios" },
  ];

  const cargaPermanenteOptions = [
    { value: null, label: "O seleccione un stándard" },
    { value: 100, label: "Piso granítico y mezcla de asiento" },
    {
      value: 200,
      label:
        "Piso granítico y mezcla de asiento + incidencia de muros sobre losa",
    },
    { value: 200, label: "Cubierta de tejas cerámicas y mezcla de asiento" },
  ];

  const SetDeSobreCargaReglamentaria = ({ target }) => {
    switch (target.name) {
      case "edificios_viviendas":
        if (!isNaN(target.value)) {
          document
            .getElementById("edificios_otros")
            .setAttribute("disabled", "");
          setSobreCarga1(target.value);
        } else {
          document
            .getElementById("edificios_otros")
            .removeAttribute("disabled");
        }
        break;

      case "edificios_otros":
        if (!isNaN(target.value)) {
          document
            .getElementById("edificios_viviendas")
            .setAttribute("disabled", "");
          setSobreCarga2(target.value);
        } else {
          document
            .getElementById("edificios_viviendas")
            .removeAttribute("disabled");
        }
        break;
      default:
    }
  };

  const setCargaPermanenteAccesoria = ({ target }) => {
    switch (target.name) {
      case "carga_exacta_kg":
        if (target.value && target.value !== "0") {
          document
            .getElementById("carga_standard")
            .setAttribute("disabled", "");
        } else {
          document.getElementById("carga_standard").removeAttribute("disabled");
        }
        setCarga1(target.valueAsNumber);
        break;

      case "carga_standard":
        if (isNaN(target.value)) {
          document
            .getElementById("carga_exacta_kg")
            .removeAttribute("disabled");
        } else {
          document
            .getElementById("carga_exacta_kg")
            .setAttribute("disabled", "");
        }
        setCarga2(target.value);
        break;
      default:
    }
  };

  const HandleClickLimpiar = (e) => {
    e.preventDefault();
    document.getElementById("form-calculo-T180").reset();
    setMostrarResultCalculatorNot(false);

    document.getElementById("edificios_otros").removeAttribute("disabled");
    document.getElementById("edificios_viviendas").removeAttribute("disabled");
    document.getElementById("carga_standard").removeAttribute("disabled");
    document.getElementById("carga_exacta_kg").removeAttribute("disabled");

    setLuzOriginal();
    setAnchoOriginal();
    setSobreCarga1(0);
    setSobreCarga2(0);
    setCarga1(0);
    setCarga2(0);
    setRes("");
  };

  const calcularT180 = (e) => {
    e.preventDefault();
    if (
      ((typeof carga1 !== "undefined" && carga1 !== null && carga1 !== "") ||
        (typeof carga2 !== "undefined" && carga2 !== null && carga2 !== "")) &&
      ((typeof sobreCarga1 !== "undefined" &&
        sobreCarga1 !== null &&
        sobreCarga1 !== "") ||
        (typeof sobreCarga2 !== "undefined" &&
          sobreCarga2 !== null &&
          sobreCarga2 !== "")) &&
      typeof luzOriginal !== "undefined" &&
      luzOriginal !== null &&
      luzOriginal !== "" &&
      typeof anchoOriginal !== "undefined" &&
      anchoOriginal !== null &&
      anchoOriginal !== ""
    ) {
      setMostrarResultCalculatorNot(true);
      setMensaje(
        "No es posible el cálculo con estos valores de carga ingresados. Revisa los valores y calcula nuevamente"
      );
      const control = anchoOriginal?.indexOf(".");
      let luz;
      let ancho;
      luz = luzOriginal * 1000;

      if (control === -1) {
        ancho = anchoOriginal * 1000;
      } else {
        const cantTotal = anchoOriginal?.length;
        const comparacion = cantTotal - control;

        if (comparacion === 2) {
          ancho = anchoOriginal.replace(".", "");
          ancho = ancho * 1000;
        }
        if (comparacion === 1) {
          ancho = anchoOriginal.replace(".", "");
          ancho = ancho * 100;
        }
        if (comparacion === 3) {
          ancho = anchoOriginal.replace(".", "");
          ancho = ancho * 10;
        }
      }

      const carga = Number(carga1) + Number(carga2);

      const sobreCarga = Number(sobreCarga1) + Number(sobreCarga2);
      const cargaTotal =
        Number(sobreCarga1) +
        Number(sobreCarga2) +
        Number(carga1) +
        Number(carga2);

      const superficie = (luz / 1000) * (ancho / 1000);

      const row_prov = t180.find((item) => item.luz === `${luz}`);

      let posible;
      let pcarga;
      let espesorbov;
      let espesorcapa;
      let espesortotal;
      let volhomigon;
      let cargaadmisible;
      let puntal;
      let pesopropio;
      let grafico;

      if (row_prov.carga1 > cargaTotal) {
        posible = "Si";
        pcarga = "Si";
        espesorbov = "17";
        espesorcapa = "4";
        espesortotal = "21";
        volhomigon = 0.048 * superficie;
        cargaadmisible = row_prov.carga1;
        puntal = row_prov.puntal1;
        pesopropio = "166";
        grafico = "";
      } else if (row_prov.carga2 > cargaTotal) {
        posible = "Si";
        pcarga = "Si";
        espesorbov = "17";
        espesorcapa = "5";
        espesortotal = "22";
        volhomigon = 0.058 * superficie;
        cargaadmisible = row_prov.carga2;
        puntal = row_prov.puntal2;
        pesopropio = "190";
        grafico = "";
      } else if (row_prov.carga3 > cargaTotal) {
        posible = "Si";
        pcarga = "Si";
        espesorbov = "21";
        espesorcapa = "5";
        espesortotal = "26";
        volhomigon = 0.066 * superficie;
        cargaadmisible = row_prov.carga3;
        puntal = row_prov.puntal3;
        pesopropio = "210";
        grafico = "";
      } else if (row_prov.carga4 > cargaTotal) {
        posible = "Si";
        pcarga = "Si";
        espesorbov = "25";
        espesorcapa = "5";
        espesortotal = "30";
        volhomigon = 0.076 * superficie;
        cargaadmisible = row_prov.carga4;
        puntal = row_prov.puntal4;
        pesopropio = "233";
        grafico = "";
      } else {
        posible = "No";
        setMostrarResultCalculatorNot(true);
      }

      let posible2;
      let pcarga2;
      let espesorbov2;
      let espesorcapa2;
      let espesortotal2;
      let volhomigon2;
      let cargaadmisible2;
      let puntal2;
      let pesopropio2;
      let grafico2;

      if (row_prov.carga5 > cargaTotal) {
        posible2 = "Si";
        pcarga2 = "Si";
        espesorbov2 = "17";
        espesorcapa2 = "4";
        espesortotal2 = "21";
        volhomigon2 = 0.057 * superficie;
        cargaadmisible2 = row_prov.carga5;
        puntal2 = row_prov.puntal5;
        pesopropio2 = "223";
        grafico2 = "";
      } else if (row_prov.carga6 > cargaTotal) {
        posible2 = "Si";
        pcarga2 = "Si";
        espesorbov2 = "17";
        espesorcapa2 = "5";
        espesortotal2 = "22";
        volhomigon2 = 0.067 * superficie;
        cargaadmisible2 = row_prov.carga6;
        puntal2 = row_prov.puntal6;
        pesopropio2 = "247";
        grafico2 = "";
      } else if (row_prov.carga7 > cargaTotal) {
        posible2 = "Si";
        pcarga2 = "Si";
        espesorbov2 = "21";
        espesorcapa2 = "5";
        espesortotal2 = "26";
        volhomigon2 = 0.081 * superficie;
        cargaadmisible2 = row_prov.carga7;
        puntal2 = row_prov.puntal7;
        pesopropio2 = "279";
        grafico2 = "";
      } else if (row_prov.carga8 > cargaTotal) {
        posible2 = "Si";
        pcarga2 = "Si";
        espesorbov2 = "25";
        espesorcapa2 = "5";
        espesortotal2 = "27";
        volhomigon2 = 0.095 * superficie;
        cargaadmisible2 = row_prov.carga8;
        puntal2 = row_prov.puntal8;
        pesopropio2 = "314";
        grafico2 = "";
      } else {
        posible2 = "No";
      }

      if (posible === "Si" && posible2 === "Si") {
        if (espesortotal2 === espesortotal && puntal2 === puntal) {
          posible2 = "No";
          pcarga2 = "No";
        }
      }

      const cantidadvig1 = Math.round(ancho / 1000 / 0.5 + 1);
      const cantidadbov1 = Math.round(((cantidadvig1 - 1) * luz) / 1000) + 1;

      const cantidadvig2 = (Math.round(ancho / 1000 / 0.6 + 1) - 2) * 2 + 2;
      const cantidadbov2 =
        Math.round(((ancho / 1000 / 0.6 + 1 - 1) * luz) / 1000) + 1;

      if (userLog) {
        setRes({
          luzOriginal,
          luz,
          anchoOriginal,
          ancho,
          superficie,
          carga,
          carga2,
          cargaTotal,
          sobreCarga,
          posible,
          pcarga,
          espesorbov,
          espesorcapa,
          espesortotal,
          volhomigon,
          cargaadmisible,
          puntal,
          pesopropio,
          grafico,
          posible2,
          pcarga2,
          espesorbov2,
          espesorcapa2,
          espesortotal2,
          volhomigon2,
          cargaadmisible2,
          puntal2,
          pesopropio2,
          grafico2,
          row_prov,
          cantidadvig1,
          cantidadvig2,
          cantidadbov1,
          cantidadbov2,
        });
      } else {
        setMensajeUser(
          "Debes estar logueado para ver los resultados de tu cálculo!"
        );
        setMostrarMensajeUserNot(true);
        const queryParams = new URLSearchParams({
          luzOriginal,
          anchoOriginal,
          sobreCarga1,
          sobreCarga2,
          carga1,
          carga2,
          t180:true
        });
    
        setTimeout(() => {
          navigate(`/clientes/login?${queryParams.toString()}`);
        }, 4000);
      }
    } else {
      setMensaje(
        "Verifica que todos los campos esten cargados. Debes cargar todos los campos de datos generales y uno de sobrecarga y de carga permanente"
      );
      setMostrarResultCalculatorNot(true);
    }
  };

  return (
    <>
      {mensajeUser && !userLog && (
        <section
          className={`bg-section-results container shadow2 mb-3 ${
            mostrarMensajeUserNot ? "d-block" : "d-none"
          }`}
        >
          <ResultCalculatorNot mensaje={mensajeUser} />
        </section>
      )}
      <form
        onSubmit={calcularT180}
        id="form-calculo-T180"
        action=""
        className="container settings__form-styles"
      >
        <fieldset className="col-12 calculadora__img-ancho-luz">

          <div className="col-12 col-sm-12 col-md-6 col-lg-6 settings__col-izquierda">
            <legend className="id-section-contacto">Datos Generales</legend>

            <div className="mb-4 col-12">
              <select
                name="luz"
                id="luz"
                placeholder="Luz (en metros)"
                onChange={({ target }) => setLuzOriginal(target.value)}
                value={luzOriginal}
              >
                {luzOptions.map((option, index) => (
                  <option key={index} value={option.value}>
                    {option.label}
                  </option>
                ))}
              </select>
            </div>
            <div className="mb-4 col-12">
              <input
                type="number"
                step="any"
                placeholder="Ancho (en metros)"
                min="0"
                className="form-control"
                onChange={({ target }) => setAnchoOriginal(target.value)}
                value={anchoOriginal}
              />
            </div>
          </div>

          <div className="col-12 col-sm-12 col-md-6 col-lg-6 settings__col-derecha">
            <img
              src={imgAnchoLuz}
              alt="esquema de ancho y luz para bovedilla hormigón"
            />
          </div>
        </fieldset>

        <fieldset className="col-12 col-sm-12 col-md-6 col-lg-6 settings__col-izquierda">

          <legend className="id-section-contacto">
            Sobrecarga reglamentaria
          </legend>
          <small>
            Carga viva solicitante en función del destino o uso (vivienda,
            oficina, cubierta, etc.)
          </small>

          <div className="mb-4 col-12">
            <select
              name="edificios_viviendas"
              id="edificios_viviendas"
              value={sobreCarga1}
              onChange={SetDeSobreCargaReglamentaria}
            >
              {buildingOptions.map((option, index) => (
                <option key={index} value={option.value}>
                  {option.label}
                </option>
              ))}
            </select>
          </div>
          <div className="mb-4 col-12">
            <select
              name="edificios_otros"
              id="edificios_otros"
              value={sobreCarga2}
              onChange={SetDeSobreCargaReglamentaria}
            >
              {otherBuildingOptions.map((option, index) => (
                <option key={index} value={option.value}>
                  {option.label}
                </option>
              ))}
            </select>
          </div>
        </fieldset>
        <fieldset className="col-12 col-sm-12 col-md-6 col-lg-6 settings__col-derecha">
          <legend className="id-section-contacto">
            Carga permanente accesoria
          </legend>

          <small>
            Carga muerta a disponer sobre losa (piso, carpetas, rellenos, muros,
            etc)
          </small>

          <div className="mb-4 col-12">
            <input
              type="number"
              step="any"
              placeholder="Ingrese la carga exacta (kg/m²)"
              className="form-control input-disabled"
              name="carga_exacta_kg"
              id="carga_exacta_kg"
              min="0"
              onChange={setCargaPermanenteAccesoria}
              value={carga1}
            />
          </div>
          <div className="mb-4 col-12">
            <select
              name="carga_standard"
              id="carga_standard"
              onChange={setCargaPermanenteAccesoria}
              value={carga2}
            >
              {cargaPermanenteOptions.map((option, index) => (
                <option key={index} value={option.value}>
                  {option.label}
                </option>
              ))}
            </select>
          </div>
        </fieldset>
        <div className="col-12 d-flex justify-content-between mt-4 buttons-center">
          <button
            onClick={HandleClickLimpiar}
            className="settings_button-border button-b-secondary"
          >
            Limpiar
          </button>
          <button
            className="settings_button-pleno bg-p-secondary"
            type="submit"
          >
            Calcular
          </button>
        </div>

        {res.posible || res.posible2 ? (
          res.posible === "Si" || res.posible2 === "Si" ? (
            <section className="bg-section-results container">
              <ResultsCalculator limpiar={HandleClickLimpiar} res={res} />
            </section>
          ) : (
            <section
              className={`bg-section-results container mb-3 ${
                mostrarResultCalculatorNot ? "d-block" : "d-none"
              }`}
            >
              <ResultCalculatorNot mensaje={mensaje} />
            </section>
          )
        ) : (
          <section
            className={`bg-section-results container mb-3 ${
              mostrarResultCalculatorNot ? "d-block" : "d-none"
            }`}
          >
            <ResultCalculatorNot mensaje={mensaje} />
          </section>
        )}
      </form>
    </>
  );
};

export default T180;
